import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Result, Modal, Space, Input, Typography } from 'antd'

import { SuccessIcon, ErroIcon, WarningIcon, InfoIcon } from '../resulticon' //动态图标
import { sendUserEmail } from '../../request/api'

let languageId = 'zh_CN'

const Success = (props) => {
  const handleClose = () => {
    props.handleModel.destroy();
  }
  return (
    <>
      <Result
        icon={<SuccessIcon />}
        title={props.messageTitle}
        subTitle={props.messageSubTitle}
        extra={[
          <Button shape='round' type='primary' key='login' onClick={props.handleClick || handleClose}>
            {props.messageBtn}
          </Button>
        ]}
      />
    </>
  )
}

const Error = (props) => {
  const handleClose = () => {
    props.handleModel.destroy();
  }
  return (
    <>
      <Result
        icon={<ErroIcon />}
        title={props.messageTitle}
        subTitle={props.messageSubTitle}
        extra={[
          <Button shape='round' type='primary' key='back' onClick={handleClose}>
            {props.messageBtn}
          </Button>
        ]}
      />
    </>
  )
}

const Info = (props) => {
  const handleClose = () => {
    props.handleModel.destroy();
  }
  return (
    <>
      <Result
        icon={<InfoIcon />}
        title={props.messageTitle}
        subTitle={props.messageSubTitle}
        extra={props.extra || [
          <Button shape='round' type='primary' key='close' onClick={handleClose}>
            {props.messageBtn}
          </Button>
        ]}
      />
    </>
  )
}

const Warning = (props) => {
  const { t, i18n } = useTranslation();
  languageId = i18n.language === 'zhCN' ? 'zh_CN' : (i18n.language === 'jaJP' ? 'ja' : 'en');
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    if (props.isOkBtn)
      setCurrent(1)
    else
      setCurrent(0)
  }, [props.isOkBtn]);

  const handleClose = () => {
    //props.backLogin();
    props.handleModel.destroy();
  }

  //发送激活邮件
  const handleSendEmaill = () => {
    setIsLoading(true)
    props.backLogin();
    sendUserEmail(props.userCode, languageId).then(res => {
      try {
        console.log('res.msg', res.msg)
        props.handleModel.destroy();
        var sucModal = Modal.success();
        sucModal.update({
          icon: '',
          content: (
            <Success
              messageTitle={t('Common.Header.Notification.Warning.Notification.Success.Title')}
              messageSubTitle={t('Common.Header.Notification.Warning.Notification.Success.SubTitle')}
              messageBtn={t('Common.Header.Notification.Warning.Notification.Success.btn')}
              handleModel={sucModal}
            />
          ),
          okButtonProps: { style: { display: 'none' } },// 隐藏确认按钮
          cancelButtonProps: { style: { display: 'none' } }, // 隐藏取消按钮
        });
      } catch (err) {
        var errModal = Modal.error();
        errModal.update({
          icon: '',
          content: (
            <Error
              messageTitle={t('Common.Header.Notification.Warning.Notification.Error.Title')}
              messageSubTitle={t('Common.Header.Notification.Warning.Notification.Error.SubTitle')}
              messageBtn={t('Common.Header.Notification.Warning.Notification.Error.btn')}
              handleModel={errModal}
            />
          ),
          okButtonProps: { style: { display: 'none' } },// 隐藏确认按钮
          cancelButtonProps: { style: { display: 'none' } }, // 隐藏取消按钮
        });
      }
      setIsLoading(false)
    })
  }

  return (
    <>
      <Result
        icon={<WarningIcon />}
        title={props.messageTitle}
        subTitle={props.messageSubTitle}
        extra={[
          <Space>
            <Button shape='round' key='back' onClick={handleClose}>
              {props.messageBtn}
            </Button>
            <Button shape='round' type='primary' loading={isLoading} className={current === 1 ? 'isShow' : 'isHide'} onClick={handleSendEmaill}>
              {t('Common.Header.Notification.Button.label')}
            </Button>
          </Space>
        ]}
      />
    </>
  )
}

const PasswordInput = (props) => {
  const [passwordValue, setPasswordValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    props.handleModel.destroy();
  }

  const handleSubmit = () => {
    if (!passwordValue) {
      Modal.warning({
        title: '提示',
        content: '请输入密码'
      });
      return;
    }
    setIsLoading(true);
    if (props.onSubmit) {
      props.onSubmit(passwordValue, handleClose, setIsLoading);
    }
  }

  return (
    <>
      <div style={{ padding: '20px 0' }}>
        <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
          {props.messageSubTitle || '请输入密码'}
        </Typography.Text>
        <Input.Password
          placeholder="请输入密码"
          value={passwordValue}
          onChange={(e) => setPasswordValue(e.target.value)}
          onPressEnter={handleSubmit}
        />
      </div>
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <Space>
          <Button shape='round' key='cancel' onClick={handleClose}>
            取消
          </Button>
          <Button shape='round' type='primary' key='submit' loading={isLoading} onClick={handleSubmit}>
            {props.messageBtn || '提交'}
          </Button>
        </Space>
      </div>
    </>
  )
}


/**
 * Confirm — 通用确认弹窗（WarningIcon 样式，含取消 + 确认两个按钮）
 *
 * 使用方式:
 *   const modal = Modal.warning()
 *   modal.update({
 *     icon: '',
 *     content: <Confirm handleModel={modal} messageTitle="..." messageSubTitle="..."
 *                       cancelText="取消" okText="确认" onOk={asyncFn} />,
 *     okButtonProps: { style: { display: 'none' } },
 *     cancelButtonProps: { style: { display: 'none' } },
 *     centered: true,
 *   })
 */
const Confirm = (props) => {
  const handleClose = () => {
    props.handleModel.destroy()
  }
  const handleOk = () => {
    props.handleModel.destroy()
    props.onOk && props.onOk()
  }
  return (
    <>
      <Result
        icon={<WarningIcon />}
        title={props.messageTitle}
        subTitle={props.messageSubTitle}
        extra={[
          <Space key="confirm-btns">
            <Button shape="round" key="cancel" onClick={handleClose}>
              {props.cancelText}
            </Button>
            <Button shape="round" type="primary" key="ok" onClick={handleOk}>
              {props.okText}
            </Button>
          </Space>
        ]}
      />
    </>
  )
}

export { Success, Error, Info, Warning, PasswordInput, Confirm }





